<template>
  <div id="editor" >
    <input type="hidden" id="tpl_name" value="">
    <input type="hidden" id="tpl_id" value="">
    <input type="hidden" id="version" value="">
    <div class="scroll">
      <editor :init="init" v-model="tpl_content"/>
    </div>

    <div class="footer-bar" id="footer-bar" style="position: relative; display: none; z-index: 2"
         v-if="clientType!=='WEB'">
      <div class="footer-bar-box" style="display: flex;">
        <div style=" display: flex; flex: 1; margin-right: 15px;">
          <div @click="save()" class="btn saveContent">保存</div>
        </div>
        <div style="width: 60%; ">
          <div @click="sign()" class="btn signed">签署该合同</div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import tinymce from "tinymce";
import "tinymce/themes/silver";
import "tinymce/icons/default";


import "tinymce/plugins/paste";
import "tinymce/plugins/lists";
import "tinymce/plugins/fullpage";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/directionality";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/visualchars";
import "tinymce/plugins/image";
import "tinymce/plugins/imagetools";
import "tinymce/plugins/code";
import "tinymce/plugins/codesample";
import "tinymce/plugins/table";
import "tinymce/plugins/charmap";
import "tinymce/plugins/hr";
import "tinymce/plugins/pagebreak";
import "tinymce/plugins/nonbreaking";
import "tinymce/plugins/anchor";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/advlist";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/textpattern";
import "tinymce/plugins/link";

import "tinymce/plugins/autoresize";

import "tinymce/plugins/autosave";

import "tinymce-plugin";
import "tinymce-plugin/plugins/tpLayout/plugin.js";
import "tinymce-plugin/plugins/tpIndent2em/plugin.js";

import Editor from '@tinymce/tinymce-vue'

import "./css/editor.css"
import importWord from "@/pages/document/plugins/importWord";
import axios from "axios";
import importWordAction from "@/pages/document/plugins/importWordAction";
import uploadImages from "@/pages/document/plugins/uploadImages";
import updateTplName from "@/pages/document/plugins/updateTplName";

export default {
  name: 'Editor',
  data() {
    return {
      defaultHeight: window.screen.height,
      footerBarHeight: 64,
      init: {},
      tpl_id: this.$route.query.tpl_id,
      contracts_id: this.$route.query.contracts_id || '',
      tpl_content: '',
      clientType: this.$route.query.clientType || 'H5',
      editor: {}
    }
  },
  components: {
    'editor': Editor
  },

  /**
   * 接受消息
   */
  mounted() {
    window.onload = () => {
      window.addEventListener('message', json => {
        switch (json.data.action) {
          case "save" :
            return this.save();
          case "sign" :
            return this.sign()
        }
      }, false)
    }

  },
  // 实例创建完成
  created() {

    this.api.loading()

    this.defaultHeight = document.documentElement.clientHeight

    if (this.$route.query.webHeight)
      this.defaultHeight = parseInt(this.$route.query.webHeight)


    if (this.$route.query.safe_area && this.$route.query.safe_area > 0)
      this.defaultHeight -= this.$route.query.safe_area


    importWord(json => {
      this.importWordStartUpload(json)
    })

    uploadImages()

    updateTplName()

    if (this.clientType === 'WEB')
      this.footerBarHeight = 0

    this.init = this.getDefaultInitConfig()


    setTimeout(() => {
      this.showFooterBar()
    }, 3000)

  },

  methods: {

    showFooterBar() {

      if (this.clientType !== 'WEB') {
        document.getElementById("footer-bar").style.display = "block"
        document.getElementById("footer-bar").style.zIndex = "99"
      }
    },

    /**
     * 设置模板名称
     * @param val
     */
    setTplName(val) {
      document.getElementById("tpl_name").value = val
    },
    /**
     * 获取模板内容
     */
    getHtmlContentByContractsId() {
      this.api.post("/v1/Contracts/readHtmlByContractsId", {
        contracts_id: this.contracts_id
      }, json => {
        this.api.hideLoading()
        if (json.code === 200) {
          this.setTplName(json.data.name)
          return this.editor.setContent(json.data.content)
        }
        this.error(json.msg)
      })
    },
    /**
     * 获取内容
     */
    getContent() {
      this.api.post("/v1/ContractsUser/read", {
        id: this.tpl_id,
        log_id: this.$route.query.log_id || ''
      }, json => {
        this.api.hideLoading()
        if (json.code === 200) {

          this.setTplName(json.data.name)
          this.editor.setContent(json.data.content)


          return
        }
        this.error(json.msg)
      })
    },

    initLink() {

    },
    /**
     * 获取内容
     * @returns {{name, id: (default.$route.query.tpl_id|string|(string | null)[]), content: *}}
     */
    getDefaultContent() {
      return {
        id: this.tpl_id,
        name: document.getElementById("tpl_name").value,
        content: this.editor.getContent().replace(/style/g, "YDQ_SAFE_UBB")
      }
    },
    /**
     * 签署模板
     */
    sign() {

      if (!this.editor.getContent())
        return this.error("合同内容不能为空")

      this.api.loading()
      this.api.post("/v1/ContractsUser/sign", this.getDefaultContent(), json => {
        if (json.code === 200) {

          if (this.clientType === "WEB")
            return window.parent.postMessage({
              action: 'createDoc',
              tpl_id: json.data.id,
              tpl_data_id: json.data.tpl_data_id
            }, '*')
          else if (this.$route.query.callback==="createDoc")
            return uni.redirectTo({
              url : `/pages/public/editor?status=success&tpl_id=${json.data.id}&tpl_data_id=${json.data.tpl_data_id}&tpl_name=${json.data.name}&tpl_version=${json.data.tpl_version}`
            });
          else
            return uni.redirectTo({
              url: "/pages/users/contractManagement/createDoc?tpl_id=" + json.data.id + "&tpl_data_id=" + json.data.tpl_data_id
            });
        }


        this.error(json.msg)
      })
    },
    /**
     * 保存模板
     */
    save() {

      if (!this.editor.getContent())
        return this.error("合同内容不能为空")

      this.api.loading()
      this.api.post("/v1/ContractsUser/save", this.getDefaultContent(), json => {
        if (json.code === 200)
          this.tpl_id = json.data.id
        //
        // this.editor.notificationManager.open({
        //   text: json.msg,
        //   type: 'success',
        //   timeout: 3000
        // });

        this.$swal({
          icon: json.code === 200 ? 'success' : 'error',
          title: json.code === 200 ? '操作成功' : '操作失败',
          text: json.msg,
          confirmButtonText: '确定'
        })
        this.api.hideLoading()
      })
    }
    ,
    /**
     * 获取时间戳
     * @returns {string}
     */
    getDate() {
      const myDate = new Date();
      return myDate.getFullYear() + "/" + myDate.getMonth() + "/" + myDate.getDate();
    },

    /**
     * 获取默认的配置信息
     */
    getDefaultInitConfig() {
      return {
        //模板
        skin_url: '/js/editor/skins/ui/oxide',
        //如果语言包不存在，指定一个语言包路径
        language_url: "/js/editor/zh_CN.js",
        //语言
        language: "zh_CN",
        //是否开启骨架屏
        skeletonScreen: false,
        //此选项允许您禁用编辑器底部状态栏中的元素路径
        elementpath: false,
        //关闭底部状态栏
        statusbar: false,
        //关闭logo
        branding: false,
        //禁用升级提示
        promotion: false,
        //手机选项
        mobile: {
          menubar: false,
          imagetools_toolbar: false,
        },
        resize: false,
        placeholder: '输入合同的内容，或点击导入按钮，导入word文件',
        height: this.defaultHeight - this.footerBarHeight,
        min_height: this.defaultHeight - this.footerBarHeight,
        max_height: this.defaultHeight - this.footerBarHeight,
        body_class: 'panel-body ',
        content_css : ' padding: 15px; ',
        object_resizing: false,
        toolbar_sticky: true,
        //此选项指定当在空的内部块元素内按下 Enter 键时如何拆分当前容器块元素
        end_container_on_empty_block: true,
        // 高级列表
        advlist_bullet_styles: 'circle,disc,square',
        // 高级列表
        advlist_number_styles: 'default,lower-alpha,lower-roman,upper-alpha,upper-roman',
        // 菜单列表
        menubar :'',
        // menubar: 'file edit insert view format table',
        // 菜单设置
        menu: {
          file: {title: '文件', items: 'newdocument tpLayout   |     restoredraft   '}
        },
        //插件
        plugins: 'importWord updateTplName tpLayout uploadImages   paste  searchreplace image directionality visualblocks visualchars imagetools  code codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount textpattern tpIndent2em autoresize autosave',
        //工具栏  https://www.tiny.cloud/docs/advanced/editor-icon-identifiers/
        toolbar: ' undo redo  |  importWordButton   updateTplNameButton bold italic underline strikethrough   | uploadImagesButton searchreplace  forecolor backcolor |  alignleft aligncenter alignright alignjustify  |  \
		                     table  bullist numlist | removeformat tpIndent2em lineheight outdent indent restoredraft | blockquote subscript superscript   | \
		                    fontselect fontsizeselect  styleselect   charmap  hr  ',
        //字体大小
        fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
        //字体格式
        font_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings,zapf dingbats;知乎配置=BlinkMacSystemFont, Helvetica Neue, PingFang SC, Microsoft YaHei, Source Han Sans SC, Noto Sans CJK SC, WenQuanYi Micro Hei, sans-serif;小米配置=Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,Heiti SC,WenQuanYi Micro Hei,sans-serif',
        //此选项允许您为 TinyMCE 提供所有“修改”日期模板都将使用的日期/时间格式。
        template_cdate_format: '[CDATE: %m/%d/%Y : %H:%M:%S]',
        //此选项允许您为 TinyMCE 提供所有“修改”日期模板都将使用的日期/时间格式。
        template_mdate_format: '[MDATE: %m/%d/%Y : %H:%M:%S]',
        //此选项允许您指定编辑器是否应解析和保留条件注释。
        allow_conditional_comments: true,
        //此选项允许您指定编辑器是否应解析并保留html在命名anchor标签内。
        allow_html_in_named_anchor: true,
        //此选项允许您在初始化时指定padding编辑器集底部的大小。body
        autoresize_bottom_margin: 120,
        //此选项使您可以指定 TinyMCE 是否应在初始化时编辑器为空时自动恢复存储在本地存储中的内容。Restore last draft这对于不知道如果通过从File菜单中选择浏览器崩溃时可以恢复丢失的工作的用户很有用。
        autosave_restore_when_empty: true,
        //此选项允许您设置编辑器在尝试关闭当前窗口时是否应提示用户告知他们有未保存的更改。默认情况下，此选项已启用，下面包含禁用此设置的示例。
        autosave_ask_before_unload: true,
        //设置为 时true，粘贴后不会删除复制内容中使用数据 URI 的 Base64 编码图像
        powerpaste_allow_local_images: false,
        //由于浏览器的限制，PowerPaste 无法支持 Microsoft Word 和 Microsoft Excel 支持的所有图像类型。当powerpaste_keep_unsupported_src设置为 时true，PowerPaste 会将src不受支持的图像的原件存储data-image-src在粘贴的图像元素的属性中。这使开发人员能够通过后处理添加进一步的图像支持。
        //例如，浏览器不允许 PowerPaste 访问文件系统。如果您的应用程序可以访问文件系统，则设置powerpaste_keep_unsupported_src为true可能允许您在后期处理期间使用原始文件路径替换不受支持的图像。
        powerpaste_keep_unsupported_src: true,
        //此选项控制如何过滤从 Microsoft Word 粘贴的内容。
        powerpaste_word_import: 'prompt',
        //此选项控制如何过滤从 Microsoft Word 和 Google Docs 以外的来源粘贴的内容。请注意，这包括从 TinyMCE 本身复制的内容。  prompt- 在尝试粘贴 HTML 内容后提示用户在清理和合并选项之间进行选择。
        powerpaste_html_import: 'prompt',
        //表格图标
        table_icons: this.getTableIco(),
        //此选项指定是否应从粘贴的内容中删除data:url图像（内联图像）。
        paste_data_images: false,
        //在弹出框中增加一个“标题”选项，开启后图片将被包含在figure（HTML5新增）内。
        image_caption: false,
        //上传文件类型
        file_picker_types: ' image ',
        //为图像属性编辑窗口添加高级属性，可以自定义图片的css样式（内置style）、边距（margin）和边框（border）。
        image_advtab: true,
        //这会将同一域中的所有 URL 转换为相对 URL。URL 将是相对于document_base_url的。
        relative_urls: false,
        remove_script_host: false,
        a11y_advanced_options: true,

        //图片对话框中上传标签开关
        image_uploadtab: true,
        //该选项默认是开启的，如禁用，则必须配置images_upload_url，即指定接收图片上传的远程地址，如未指定该配置，则禁用无效。
        images_upload_url: false,
        //开启跨域白名单，及使用 imagetools_proxy 配置图片代理
        imagetools_cors_hosts: ['www.tinymce.com', 'codepen.io'],
        //图片地址基本目录
        images_upload_base_path: '',
        //图片上传成功
        images_upload_handler: (blobInfo, success, failure) => {
          this.images_upload_handler(blobInfo, success, failure)
        },
        //文件选择标签切换
        file_picker_callback: function (callback, value, meta) {
          if (meta.filetype === 'image')
            return document.getElementsByClassName('tox-dialog__body-nav-item')[2].click()
        },
        //禁用图片自动上传
        automatic_uploads: false,
        //默认链接打开方式
        default_link_target: '_blank',
        //对话框中“标题”的显示开关
        link_title: false,
        //按tab键插入三个&nbsp;。一直按一直插。
        nonbreaking_force_tab: true,

        // paste_postprocess: async function (plugin, args) {
        //   console.log('paste')
        // },
        // 内容样式标签
        content_style: "img {max-width: 80% !important;  width: auto;  height: auto; -webkit-touch-callout: none;  -webkit-user-select: none; }",
        // 初始化完成
        init_instance_callback: editor => {
          this.editor = editor

          this.initCallback()
          editor.on("click", object => {
            if (object.target.className === "editor-image") {
              tinymce.activeEditor.execCommand('mceEditImage');
              object.preventDefault();
            }
          })
        },
        // 开始初始化
        setup(editor) {
        },
        //自动转换URL
        convert_urls: false
      }
    },
    /**
     * 编辑器初始化完成
     */
    initCallback() {

      this.showFooterBar()

      // console.log(this.editor)

      document.getElementById("version").value = this.$route.query.version || ''
      document.getElementById("tpl_id").value = this.tpl_id || ''
      //如果存在模板id
      if (this.tpl_id)
        return this.getContent()
      else if (this.$route.query.contracts_id)
        return this.getHtmlContentByContractsId();

      this.api.hideLoading()

      this.setTplName(`新建空白模板${this.getDate()}`)


      setTimeout(() => {
        this.$swal({
          icon: 'question',
          title: '导入文档',
          text: "是否导入word文件到编辑器中进行编辑? ",
          confirmButtonText: '选择文件',
          showCancelButton: true,
          cancelButtonText: '不导入',
        }).then((result) => {
          if (result.isConfirmed) {
            importWordAction.init(json => {
              this.importWordStartUpload(json)
            })
          }
        })
      }, 2000)

    },

    /**
     * 开始上传文件
     * @param file
     */
    importWordStartUpload(file) {

      this.api.loading()
      let formData = new FormData();
      formData.append('file', file);
      let params = {
        method: 'post',
        url: `${this.api.API_ROOT}/v1/UploadsImportWordTmp.json`,
        data: formData,
        transformRequest: [function () {
          return formData;
        }],
        timeout: 60 * 1000,
        headers: this.api.getHeaders()
      };
      axios(params).then(response => {
        this.api.hideLoading()
        if (response.data.code !== 200)
          return this.error(response.data.msg)

        //导入成功
        this.editor.setContent(response.data.data.content)
        this.setTplName(`模板导入${this.getDate()}`)
      }).catch(error => {
        this.error('网络故障，请稍后重试')
      })
    },

    /**
     * 输出错误原因
     * @param errorMsg
     */
    error(errorMsg) {
      this.api.hideLoading()
      this.$swal({
        icon: 'error',
        title: '处理失败',
        text: errorMsg,
        confirmButtonText: '确定'
      })
    },

    /**
     * 图片上传事件
     * @param blobInfo
     * @param success
     * @param failure
     */
    images_upload_handler(blobInfo, success, failure) {
      const reader = new FileReader();
      reader.readAsDataURL(blobInfo.blob());
      reader.onload = function () {
        success(reader.result)
      };
    }
    ,
    getTableIco() {
      return { // 以下下为默认配置
        'align-right-table': '<svg width="24" height="24"><path d="M5 5h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 1 1 0-2zm6 4h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 0 1 0-2zm0 8h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 0 1 0-2zm-6-4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 0 1 0-2z" fill-rule="evenodd"></path></svg>',
        'align-left-table': '<svg width="24" height="24"><path d="M5 5h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 1 1 0-2zm0 4h8c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 1 1 0-2zm0 8h8c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 0 1 0-2zm0-4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 0 1 0-2z" fill-rule="evenodd"></path></svg>',
        'align-center-table': '<svg width="24" height="24"><path d="M5 5h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 1 1 0-2zm3 4h8c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 1 1 0-2zm0 8h8c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 0 1 0-2zm-3-4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 0 1 0-2z" fill-rule="evenodd"></path></svg>'
      }
    }
  }
}
</script>
<style>
.footer-bar-box {
  max-width: 600px;
  padding: 10px 30px 10px 30px;
  margin: 0 auto;
}

.footer-bar {
  box-shadow: 0 -5px 5px 0 rgb(191 191 191 / 20%);
  background: #ffffff;
}

.saveContent {
  background: transparent !important;
  color: #333 !important;
  border: 1px solid #333;
  border-radius: 44px;
  height: 44px;
}

.signed {
  font-weight: bold;
  background: #e54d42;
  color: #ffffff !important;
  border: 1px solid #e54d42;
  border-radius: 44px;
  height: 44px;
  box-shadow: 0 5px 7px 0 rgb(235 9 9 / 20%);
}

body {
  background: #f1f1f1;
}


@media only screen and (min-width :900px){

  .tox .tox-sidebar-wrap {
    padding: 50px;
    box-shadow: 0 1px 5px 1px rgb(69 65 78 / 10%);
    background: #fff;
    max-width: 860px;
    margin: 0 auto;
    border-radius: 1px;
    margin-top: 15px;
    width: 100%;
  }

}
</style>
